export default __webpack_public_path__ + "static/media/new-campaign-1x.7b1c8f55.jpg";